var _path, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    enableBackground: "new 0 0 90 90",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.8,35.7C81.8,25.3,81.8,0,45,0C8.5,0,8.2,25.3,8.2,35.7c0,15.5,5.5,14.6,2.9,25.4c-1.6,6.8,4.8,12.6,11.8,12.6  c0,0,6.7-1.6,6.7,7.6c0,4.3,2.6,8,2.6,8s2.5-4.3,2.5-9.3h0c0,5,2.6,9.3,2.6,9.3s2.5-4,2.5-8.4c0,4.3,2.6,8.8,2.6,8.8  s2.4-4.2,2.5-8.3c0.1,4.2,2.5,8.4,2.5,8.4s2.6-4.3,2.6-8.7c0,4.3,2.5,8.1,2.5,8.1s2.6-4.3,2.6-9.3h0c0,5,2.5,9.3,2.5,9.3  s2.6-4,2.6-8.4c0-9.2,6.7-7.5,6.7-7.5c7,0,13.4-5.7,11.8-12.5C76.3,50.2,81.8,51.2,81.8,35.7z M33.6,62.4c0,0-9.2,4.8-13.8,1.3  c-4.6-3.5-3.6-14.4-3.6-14.4s0.8-8.9,7-3.1c6.2,5.8,8.2,6.1,11.4,5.8c1.6-0.2,5.3-1.1,5.3,3.6C39.7,60.4,33.6,62.4,33.6,62.4z   M43.1,70c-2.2,0-1.4-1.7-1.4-3.9c0-2.1,0.6-3.9,1.4-3.9c0.8,0,1.4,1.7,1.4,3.9C44.5,68.3,45,70,43.1,70z M47.2,70  c-2.2,0-1.4-1.7-1.4-3.9c0-2.1,0.6-3.9,1.4-3.9c0.8,0,1.4,1.7,1.4,3.9C48.6,68.3,49.1,70,47.2,70z M70.2,63.7  c-4.6,3.5-13.8-1.3-13.8-1.3s-6.1-2.1-6.2-6.8c-0.1-4.7,3.7-3.8,5.3-3.6c3.2,0.3,5.2,0,11.4-5.8c6.2-5.8,7,3.1,7,3.1  S74.7,60.2,70.2,63.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    d: "M-107,81.1c0,4.2-2.4,6.5-2.4,6.5s-2.5-2.3-2.5-6.5c0,4.2-2.4,6.5-2.4,6.5   s-2.5-2.3-2.5-6.5h0c0,4.2-2.4,6.5-2.4,6.5s-2.5-2.3-2.5-6.5c0-8.9-6.5-7.4-6.5-7.4c-6.8,0-13-5.8-11.4-12.3   c2.5-10.5-2.8-9-2.8-24.8c0-20,16.2-36.2,36.2-36.2",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    d: "M-107,81.1c0,4.2,2.4,6.5,2.4,6.5s2.5-2.3,2.5-6.5c0,4.2,2.4,6.5,2.4,6.5   s2.5-2.3,2.5-6.5h0c0,4.2,2.4,6.5,2.4,6.5s2.5-2.3,2.5-6.5c0-8.9,6.5-7.4,6.5-7.4c6.8,0,13-5.8,11.4-12.3c-2.5-10.5,2.8-9,2.8-24.8   c0-20-16.2-36.2-36.2-36.2",
    fill: "#ffffff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    d: "M-96.9,52.8c3.1,0.3,5,0,11-5.6s6.8,3,6.8,3s0.9,10.5-3.5,13.9   C-87,67.6-96,62.9-96,62.9s-5.9-2-6-6.6S-98.4,52.7-96.9,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    d: "M-117.1,52.8c-3.1,0.3-5,0-11-5.6c-6-5.6-6.8,3-6.8,3   s-0.9,10.5,3.5,13.9c4.4,3.4,13.3-1.2,13.3-1.2s5.9-2,6-6.6S-115.6,52.7-117.1,52.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    d: "M-107.6,66.5c0,2.1,0.5,3.8-1.3,3.8c-2.1,0-1.3-1.7-1.3-3.8   s0.6-3.8,1.3-3.8S-107.6,64.4-107.6,66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    d: "M-103.6,66.5c0,2.1,0.5,3.8-1.3,3.8c-2.1,0-1.3-1.7-1.3-3.8   s0.6-3.8,1.3-3.8S-103.6,64.4-103.6,66.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHackIcon);
export default __webpack_public_path__ + "static/media/hack-icon.2d29a42dd1a2b4bb98b34f4f89a238e5.svg";
export { ForwardRef as ReactComponent };